import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { makeStyles } from '@material-ui/core/styles';
import { getFormatedDate } from '../../../../helper';
import { formatToKOrM, formatToKOrMWithoutDecimal } from '../../../../helper';




const useStyles = makeStyles((_theme) => ({
  chartContainer: {
    position: 'relative',
    overflow: 'hidden',
},
sliderContainer: {
    margin: '20px 0',
    padding: '0 30px',
    position: 'relative',
    maxWidth: '600px',
    marginLeft: 'auto',
    marginRight: 'auto',
},
sliderWrapper: {
    position: 'relative',
    height: '8px',
    display: 'flex',
    alignItems: 'center',
},
slider: {
    WebkitAppearance: 'none',
    width: '100%',
    height: '4px',
    background: '#e0e0e0',
    borderRadius: '2px',
    outline: 'none',
    '&::-webkit-slider-thumb': {
        WebkitAppearance: 'none',
        width: '20px',
        height: '20px',
        background: '#0067A1',
        borderRadius: '50%',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        '&:hover': {
            transform: 'scale(1.1)',
            background: '#004d80',
        },
        '&:active': {
            transform: 'scale(1)',
        }
    },
},
pageIndicator: {
    position: 'absolute',
    right: '0',
    bottom: '-24px',
    color: '#666',
    fontSize: '0.8rem',
    fontWeight: 400,
    fontFamily: 'system-ui, sans-serif',
    '& span': {
        color: '#0067A1',
        fontWeight: 500,
    }
},
progressTrack: {
    position: 'absolute',
    height: '4px',
    background: '#0067A1',
    borderRadius: '2px',
    transition: 'width 0.3s ease',
},
}));

const MultiBarPOOSChart = ({ graphData = [], activeTab, type, isSwichON = false, showReportRunDate = false }) => {
  const classes = useStyles();
  const [borderRadius, setBorderRadius] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

  useEffect(() => {
    setCurrentPage(0);
  }, [activeTab]);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < 1000) {
        setBorderRadius(2);
      } else if (screenWidth < 1500) {
        setBorderRadius(5);
      } else {
        setBorderRadius(7);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const totalItems = graphData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Data mapping based on `activeTab`
  let seriesData = [];
  let yAxisTitle = '';
  let categories = graphData?.map((item) => getFormatedDate(item?.ModelRunDate) || 'Unknown Metric');
  
  if (activeTab === 'Recom vs Active') { 
    seriesData = [
      {
        name: 'Recommendations',
        data: graphData?.map((item) => item?.Recommended || 0),
      },
      {
        name: 'Active',
        data: graphData.map((item) => item?.Active || 0),
      },
      {
        name: 'Rejection',
        data: graphData?.map((item) => item?.Rejected || 0),
      },
      {
        name: 'Pending',
        data: graphData?.map((item) => item?.Pending || 0),
      },
    ];
    yAxisTitle = type === "SKU" ? '# of SKUs' : type === "Cases" ? "# of cases" : type;

  } else if(activeTab === "N POOS Reason"){
    seriesData = [
      {
        name: 'Demand Planning Issue',
        data: graphData?.map((item) => item?.DM_Demand_Planning_Issue || 0),
      },
      {
        name: 'Capacity Constraints',
        data: graphData.map((item) => item?.CX_Capacity_Constraints || 0),
      },
      {
        name: 'FG Quality Failures',
        data: graphData.map((item) => item?.FQ_FG_Quality_Failures || 0),
      },
      {
        name: 'DM : Demand Planning Issue; FG: FG Quality Failures',
        data: graphData.map((item) => item?.PX_Production_Failures || 0),
      },
      {
        name: 'Other',
        data: graphData.map((item) => item?.Others || 0),
      },
    ];
    yAxisTitle = (type === "Dollars" ? 'Risk in $' : `# No. of ${type}`);

  } else if(activeTab === "R POOS Reason"){
    seriesData = [
      {
        name: 'Demand Planning Issue',
        data: graphData?.map((item) => item?.DM_Demand_Planning_Issue || 0),
      },
      {
        name: 'FG Quality Failures',
        data: graphData?.map((item) => item?.FQ_FG_Quality_Failures || 0),
      },
      {
        name: 'DM : Demand Planning Issue; FG: FG Quality Failures',
        data: graphData.map((item) => item?.PX_Production_Failures || 0),
      },
      {
        name: 'Supply Planning Errors',
        data: graphData.map((item) => item?.SX_Supply_Planning_Errors || 0),
      },
      {
        name: 'Other',
        data: graphData.map((item) => item?.Others || 0),
      },
    ];
    yAxisTitle = (type === "Dollars" ? 'Risk in $' : `# No. of ${type}`);

  } else if(activeTab === "N POOS Risk"){
    if(isSwichON){
      seriesData = [
        {
          name: "",
          data: graphData?.map((item) => item["1_Value"] || 0),
        },
        {
          name: "",
          data: graphData?.map((item) => item["2_Value"] || 0),
        },
        {
          name: "",
          data: graphData?.map((item) => item["3_Value"] || 0),
        },
        {
          name: "",
          data: graphData?.map((item) => item["4_Value"] || 0),
        },
        {
          name: "",
          data: graphData?.map((item) => item["5_Value"] || 0),
        },
      ];
    }else{
      seriesData = [
        {
          name: 'N POOS Risk',
          data: graphData?.map((item) => item?.Value || 0),
        },
      ];
    }
    yAxisTitle = (type === "Dollars") ? 'Risk in $' : `# No. of ${type}`;

  } else if(activeTab === "R POOS Risk"){
    if(isSwichON){
      seriesData = [
        {
          name: "",
          data: graphData?.map((item) => item["1_Value"] || 0),
        },
        {
          name: "",
          data: graphData?.map((item) => item["2_Value"] || 0),
        },
        {
          name: "",
          data: graphData?.map((item) => item["3_Value"] || 0),
        },
        {
          name: "",
          data: graphData?.map((item) => item["4_Value"] || 0),
        },
        {
          name: "",
          data: graphData?.map((item) => item["5_Value"] || 0),
        },
      ];
    }else{
      seriesData = [
        {
          name: 'R POOS Risk',
          data: graphData?.map((item) => item?.Value || 0),
        },
      ];
    }
    yAxisTitle = (type === "Dollars") ? 'Risk in $' : `# No. of ${type}`;
  }
   // Slice data for current page
   const slicedCategories = categories?.slice(startIndex, endIndex);
   const slicedSeries = seriesData?.map(s => ({
       ...s,
       data: s.data.slice(startIndex, endIndex)
   }));

  const getFormatedTooltip = (dataPointIndex, seriesIndex, val) => {
    if ((activeTab === "N POOS Risk" || activeTab === "R POOS Risk") && isSwichON) {
      if(type === "Dollars"){
        if(seriesIndex === 0){
          return `${graphData[dataPointIndex]["1_Name"]} : &nbsp $${formatToKOrM(graphData[dataPointIndex]["1_Value"])}`;
        } else if(seriesIndex === 1){
          return `${graphData[dataPointIndex]["2_Name"]} : &nbsp $${formatToKOrM(graphData[dataPointIndex]["2_Value"])}`;
        }else if(seriesIndex === 2){
          return `${graphData[dataPointIndex]["3_Name"]} : &nbsp $${formatToKOrM(graphData[dataPointIndex]["3_Value"])}`;
        }else if(seriesIndex === 3){
          return `${graphData[dataPointIndex]["4_Name"]} : &nbsp $${formatToKOrM(graphData[dataPointIndex]["4_Value"])}`;
        }else if(seriesIndex === 4){
          return `${graphData[dataPointIndex]["5_Name"]} : &nbsp $${formatToKOrM(graphData[dataPointIndex]["5_Value"])}`;
        }
      }else{
        if(seriesIndex === 0){
          return `${graphData[dataPointIndex]["1_Name"]} : &nbsp ${formatToKOrMWithoutDecimal(graphData[dataPointIndex]["1_Value"])}`;
        } else if(seriesIndex === 1){
          return `${graphData[dataPointIndex]["2_Name"]} : &nbsp ${formatToKOrMWithoutDecimal(graphData[dataPointIndex]["2_Value"])}`;
        }else if(seriesIndex === 2){
          return `${graphData[dataPointIndex]["3_Name"]} : &nbsp ${formatToKOrMWithoutDecimal(graphData[dataPointIndex]["3_Value"])}`;
        }else if(seriesIndex === 3){
          return `${graphData[dataPointIndex]["4_Name"]} : &nbsp ${formatToKOrMWithoutDecimal(graphData[dataPointIndex]["4_Value"])}`;
        }else if(seriesIndex === 4){
          return `${graphData[dataPointIndex]["5_Name"]} : &nbsp ${formatToKOrMWithoutDecimal(graphData[dataPointIndex]["5_Value"])}`;
        }
      }
    }else {
      if(type === "Dollars"){
        return `$${formatToKOrM(val)}`;
      }else{
        return `${formatToKOrMWithoutDecimal(val)}`;
      }
    }
  };

  // Chart options
  const options = {
    chart: {
      height: 350,
      type: 'bar',
      stacked: false,
      toolbar: { show: false },
      animations: {
        enabled: true,
        easing: 'easeInOutQuad',
        speed: 600,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: (activeTab === "N POOS Risk" || activeTab === "R POOS Risk") && !isSwichON ? "20%" : "50%",
        borderRadius: borderRadius,
        borderRadiusApplication: 'end',
      },
    },
    dataLabels: { enabled: false },
    stroke: { width: 1 },
    series: slicedSeries,
    colors: ['#EC6FBD', '#A4D65D', '#01B2AA',"#0067A1", "#FFC300"],
    xaxis: {
      categories: slicedCategories,
      title: {
        text: showReportRunDate ? "Report Run Date" : "",
        style: {
          fontSize: '12px',
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 500,
          color: '#333',
        },
      },
    },
    yaxis: {
      title: {
        text: yAxisTitle,
        style: {
          fontSize: '12px',
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 500,
          color: '#333',
        },
      },
      labels: {
        formatter: (value) => type === "Dollars" ? `$${formatToKOrMWithoutDecimal(value)}`: formatToKOrMWithoutDecimal(value), // Ensure no decimals
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        //formatter: (val) => type === "Dollars" ? `$${formatToKOrM(val)}` : formatToKOrMWithoutDecimal(val),
        formatter: (val, { seriesIndex, dataPointIndex }) => getFormatedTooltip(dataPointIndex, seriesIndex, val),
  
      },
    },
    legend: {
      show: isSwichON ? false : true,
      position: 'top',
      horizontalAlign: 'left',
      markers: {
        width: 12,
        height: 12,
        radius: 10,
        shape: "circle",
      },
    },
    grid: { show: false },
  };

  return (
    <div className="grouped-bar-chart">
      <ReactApexChart options={options} series={slicedSeries} type="bar" height={350} />

      {totalPages > 1 && (
                <div className={classes.sliderContainer}>
                    <div className={classes.sliderWrapper}>
                        <div
                            className={classes.progressTrack}
                            style={{
                                width: `${((currentPage + 1) / totalPages) * 100}%`,
                                opacity: 0.3
                            }}
                        />
                        <input
                            type="range"
                            min="0"
                            max={totalPages - 1}
                            value={currentPage}
                            onChange={(e) => setCurrentPage(parseInt(e.target.value, 10))}
                            className={classes.slider}
                        />
                    </div>
                    <div className={classes.pageIndicator}>
                        <span>{currentPage + 1}</span> / {totalPages}
                    </div>
                </div>
            )}
    </div>
  );
};

export default MultiBarPOOSChart;